import { render, staticRenderFns } from "./PrevPage.vue?vue&type=template&id=c5f1c956&scoped=true&"
import script from "./PrevPage.vue?vue&type=script&lang=js&"
export * from "./PrevPage.vue?vue&type=script&lang=js&"
import style0 from "./PrevPage.vue?vue&type=style&index=0&id=c5f1c956&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f1c956",
  null
  
)

export default component.exports